<template>
    <div class="bg-f9f9f9">
        <Mainlayout></Mainlayout>
        <br /> <br /> <br /> <br />
        <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
    
            <CCard class="bg-white b-20" style="border:none">
                <h3 class="custom-48px-400 mt-5"> {{ $t('List of Club') }}
                    <label class="custom-48px-600">{{ $t('Sport') }}</label>
                </h3>
    
                <label class="text-center custom-label-grey"> {{ $t('description_teams') }}</label>
                <CRow class="m-3">
                    <CCol sm="3" v-for="item in team" v-bind:key="item.Id">
                        <CCard class="border-f5f5f5" @click="OpenTeam(item)">
                            <div class="text-center m-2">
                                <img src="../assets/img/defaultteam.png" style="max-width:80px" />
                                <h3 class="custom-20px-700 font-color-171717">
                                    {{ item.TeamName }}
                                </h3>
                                <h5 class="custom-16px-500 font-color-858585">
                                    {{ item.Category }}
                                </h5>
                            </div>
                        </CCard>
                    </CCol>
                </CRow>
            </CCard>
        </CCol>
    
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
                <div class="text-center">
                    <br />
                    <h1 class="custom-48px-500 text-black poppin-font text-48px">
                        {{ $t('Schedule') }}
                    </h1>
                    <div class="text-center mt-4">
                        <CCol sm="12" style="width: 90%; margin: auto;">
                            <CRow>
                                <CCol sm="12">
    
                                    <div class="calendar-container">
    <div class="calendar-grid">
        <div class="calendar-day-header" v-for="day in daysOfWeek" :key="day">{{ day }}</div>
        <div v-for="day in daysInMonth" :key="day.date" class="calendar-day-box" :class="{ 'current-day': isToday(day.date) }">
            <span class="day-number">{{ day.date.getDate() }}</span>
            <div v-if="day.events.length > 0" class="events">
                <div v-for="event in day.events" :key="event.Id" class="event-item" @click="GoToDetail(event.Id)">
                    {{ event.Title }}
                </div>
            </div>
        </div>
    </div>
</div>
    
    
                                </CCol>
                                <CCol sm="12">
                                    <CRow>
                                        <CCol sm="6">
                                            <!-- <h3 class="custom-20px-600 text-left mt-4">18 January, 2024</h3> -->
                                        </CCol>
                                        <CCol sm="6">
                                            <div class="text-right float-right">
                                                <CSelect class="mb-0 mx-1 mt-4" size="sm" value="Medium" :options="['Today','Tomorrow']" custom/>
                                            </div>
                                        </CCol>
                                        <CCol sm="3" v-for="(item,index) in tour" v-bind:key="item.Id">
                                            <CCard class="p-2">
    
                                                <img v-if="item.FilePath != null" :src="getThumbnail(index)" style="max-width: 100%;border-radius:20px" />
                                                <img v-else src="../assets/img/photo1.png" />
                                                <CRow>
                                                    <CCol sm="6">
                                                        <div class="custom-label-tag-blue-light mt-2">
                                                            {{ item.Time }}
                                                        </div>
                                                    </CCol>
                                                    <CCol sm="6">
                                                        <div class="mt-2">
    
                                                            <img style="width:20px" src="../assets/img/user.png" /> Registered
                                                        </div>
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <h3 class="custom-14px-500 text-left mt-3">
                                                            <b>
                                                                                        {{ item.Title }}
                                                                                    </b>
                                                        </h3>
                                                    </CCol>
                                                    <CCol sm="8">
                                                        <p class="custom-16px-600 text-left"><b>RM {{ item.Amount }}</b></p>
                                                    </CCol>
                                                    <CCol sm="4">
                                                        <p class="custom-14px-500" @click="GoToDetail(item.Id)">Join Now <img style="width:20px" src="../assets/img/arrow-right1.png" /></p>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCol>
                                        <!-- <CCol sm="4">
                                                            <CCard class="p-2">
                                                                <img src="../assets/img/photo1.png" />
                                                                <CRow>
                                                                    <CCol sm="6">
                                                                        <div class="custom-label-tag-blue-light mt-2">
                                                                            25 Mei 2024 (Sabtu)
                                                                        </div>
                                                                    </CCol>
                                                                    <CCol sm="6">
                                                                        <div class="mt-2">
                                                                            <img style="width:20px" src="../assets/img/user.png" /> 112 Registered
                                                                        </div>
                                                                    </CCol>
                                                                    <CCol sm="12">
                                                                        <h3 class="custom-14px-500 text-left mt-3">
                                                                            <b>
                                                                                        KEJOHANAN PINGPONG BERPASUKAN NOVIS PUTRAJAYA 2024
                                                                                    </b>
                                                                        </h3>
                                                                    </CCol>
                                                                    <CCol sm="8">
                                                                        <p class="custom-16px-600 text-left"><b>RM 150.00</b></p>
                                                                    </CCol>
                                                                    <CCol sm="4">
                                                                        <p class="custom-14px-500">Join Now <img style="width:20px" src="../assets/img/arrow-right1.png" /></p>
                                                                    </CCol>
                                                                </CRow>
                                                            </CCard>
                                                        </CCol> -->
    
                                    </CRow>
                                </CCol>
    
    
                            </CRow>
                        </CCol>
                    </div>
    
    
                </div>
            </CCol>
        </CCol>
    
        <CCol sm="12">
            <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center custom-card-grey mb-5 mt-5">
                    <h3 class="custom-48px-600 mt-5"> {{ $t('Have a question or feedback?') }}</h3>
                    <p class="custom-16px-400 color-171717"> {{ $t('Have a question or feedback?') }} {{ $t('fill_out') }}</p>
                    <br /><br />
                    <span class="custom-blur-radius-bottom-right p-10 mt-5 text-white p-20 mb-5">
                                        {{ $t('Contact Us') }} <img style="width:20px" src="../assets/img/Calling.png" />
                                                                       
                                                                        </span>
                    <br /><br /> <br /><br />
    
                </div>
    
            </CCol>
        </CCol>
    
        <div v-if="isPopupTeam" class="popup-all backdrop-all">
            <div class="popup-all2">
                <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                </div>
    
                <!-- Popup content -->
                <div class="custom-scroll">
                    <div class="text-left" v-for="item in detailTeam" v-bind:key="item.Id">
                        <CRow>
                            <CCol sm="1"><img src="../assets/img/defaultteam.png" style="max-width:50px" /></CCol>
                            <CCol sm="11">
                                <h3 class="custom-20px-600 text-left mt-2">{{ item.TeamName }}</h3>
                            </CCol>
                        </CRow>
    
                            <div class="m-1">
                                <table class="table p-20 table-responsive-sm" style="width:100% !important">
                                    <thead style="background-color: #064BB4;color:#fff">
                                        <th>No</th>
                                        <th>Player Name</th>
                                        <th>Sport Category</th>
                                        <th>ID Number</th>
                                        <th>Ranking Point</th>
                                        <th>Ranking No</th>
                                        <th>Status</th>
                                    </thead>
                                    <tbody v-for="(items, index) in item.ListTeam" v-bind:key="items.Id">
                                        <tr>
                                            <td>{{ index +1 }}</td>
                                            <td>{{items.Name }}</td>
                                            <td>{{ items.Category }}</td>
                                            <td>{{ formatIdentityNumber(items.IdentityNumber) }}</td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <img src="../assets/img/triangle2.png" style="max-width:10px" />
                                            </td>
                                        </tr>
    
                                    </tbody>
                                </table>
                            </div>
                     
                    </div>
                </div>
            </div>
        </div>
    
    
    
    
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            participant: [],
            tour: [],
            team: [],
            detailTeam: [],

            isPopupTeam: false,

            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

        };
    },
    computed: {
        CreationDate() {
            return moment().startOf('day'); // Start of today
        },
        daysInMonth() {
            const days = [];
            const date = new Date(this.currentYear, this.currentMonth, 1);

            // Adjust start date to Sunday of the week
            date.setDate(date.getDate() - date.getDay());

            // Loop through each day in the calendar grid (5-6 weeks typically)
            for (let i = 0; i < 42; i++) {
                const dayEvents = this.getEventsForDate(date);
                days.push({ date: new Date(date), events: dayEvents });
                date.setDate(date.getDate() + 1); // Go to next day
            }
            return days;
        },
        monthName() {
            return new Date(this.currentYear, this.currentMonth).toLocaleString("default", { month: "long" });
        }
    },
    created() {
        AOS.init();

    },
    async mounted() {

        this.GetListParticipant();
        this.GetListTour();
        this.GetListTeam();
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },

        GetListParticipant() {
            this.$API
                .get(this.$GetListParticipant, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.participant = response.data;
                    }
                });
        },
        GetListTour() {
            this.$API
                .get(this.$GetListTournamentPublished)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.tour = response.data;
                        this.getThumbnail(this.tour.FilePath);
                    }
                });
        },
        GetListTeam() {
            this.$API
                .get(this.$GetListTeam)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.team = response.data;
                    }
                });
        },
        OpenTeam(item) {
            this.GetListTeamById(item.Id);
            this.isPopupTeam = true;
        },
        getThumbnail(index) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.tour[index].FilePath
            );
        },
        GetListTeamById(id) {
            this.$API
                .get(this.$GetListTeamById + "?id=" + id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.detailTeam = response.data;
                    }
                });
        },
        closePopup() {
            this.isPopupTeam = false;
        },
        formatIdentityNumber(identityNumber) {
      // Convert identityNumber to a string, ensure it's not undefined or null
      const idStr = String(identityNumber || '');

      // If identityNumber has at least 4 digits, format it, otherwise return masked only
      if (idStr.length >= 4) {
        // Return the masked format with the last 4 digits
        return `******** ${idStr.slice(-4)}`;
      } else {
        // If the string is too short, return only the masked part
        return '********' + idStr;
      }
    },
    GoToDetail(id) {
            this.$router.push("RegisterGames?id=" + id);
        },
        getEventsForDate(date) {
            // Get events that match the specific day
            return this.tour.filter(event => {
                const eventDate = new Date(event.Start);
                return (
                    eventDate.getFullYear() === date.getFullYear() &&
                    eventDate.getMonth() === date.getMonth() &&
                    eventDate.getDate() === date.getDate()
                );
            });
        },
        isToday(date) {
            const today = new Date();
            return (
                today.getFullYear() === date.getFullYear() &&
                today.getMonth() === date.getMonth() &&
                today.getDate() === date.getDate()
            );
        },
        previousMonth() {
            if (this.currentMonth === 0) {
                this.currentMonth = 11;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }
        },
        nextMonth() {
            if (this.currentMonth === 11) {
                this.currentMonth = 0;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }
        }



    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>